import {FC, MouseEventHandler} from "react";
import {Button, ButtonSize} from "@interstate/components/Button";
import {MinusCircleIcon} from "@interstate/components/Icons";
import {useInterstateToken} from "@interstate/components/InterstateThemeProvider";
import {Tooltip} from "@interstate/components/Tooltip";
import "./RemoveButton.scss";

export interface RemoveButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement>;
  size?: ButtonSize;
  qualifier: string;
  tooltip: string;
  inline?: boolean;
}

export const RemoveButton: FC<RemoveButtonProps> = ({
  onClick,
  size = "default",
  qualifier,
  tooltip,
  inline = false
}) => {
  const token = useInterstateToken();
  const className = inline
    ? "remove-button remove-button--inline"
    : "remove-button";

  return (
    <Tooltip position={"top"} toolTipContent={tooltip} size={"small"}>
      <Button
        id={`remove-${qualifier}-button`}
        data-testid={`remove-${qualifier}-button`}
        className={className}
        icon={
          <MinusCircleIcon
            className={"remove-icon"}
            color={token("sem.color.border.error")}
          />
        }
        size={size}
        buttonStyle={"secondary"}
        onClick={onClick}
      />
    </Tooltip>
  );
};
